import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=6b0ca166&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetails.vue?vue&type=style&index=0&id=6b0ca166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ca166",
  null
  
)

export default component.exports